<!--婴幼儿管理-->
<template>
  <div>
    <el-form ref="registerRef" :model="createParam" :rules="rules" label-width="120px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="手机号:" prop="userPhone">
            <el-input style="width: 270px" v-model="createParam.userPhone" placeholder="" maxlength="11"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="版本:">
            <el-select v-model="createParam.lessonId" placeholder="请选择" style="width: 270px" 
              @change="changeLessonIdC">
              <el-option v-for="item in [
                { label: 'A', value: 2 },
                { label: 'B', value: 1 },
              ]" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="会员姓名:" prop="name">
            <el-input style="width: 270px" v-model="createParam.name" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="体验卡:" prop="expCardId">
            <el-select @change="changeExpCard" style="width: 270px" v-model="createParam.expCardId" placeholder="请选择">
              <el-option v-for="item in storeLessonExpCards" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="家长姓名:">
            <el-input style="width: 270px" v-model="createParam.userName" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="体验卡价格:" prop="expCardPay">
            <el-input-number style="width: 270px" v-model="createParam.expCardPay" placeholder=""></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="小名:" prop="petName">
            <el-input style="width: 270px" v-model="createParam.petName" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- <el-form-item label="次数:" prop="expCardNum">
            <el-input-number
              style="width: 270px"
              v-model="createParam.expCardNum"
              placeholder=""
            ></el-input-number>
          </el-form-item> -->
          <el-form-item label="课时:" prop="expCardNum">
            <el-input-number style="width: 270px" placeholder="" :precision="0" :min="1"
              v-model="createParam.expCardNum"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="性别:" prop="gender">
            <el-select v-model="createParam.gender" placeholder="请选择" style="width: 270px">
              <el-option v-for="item in genderOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-col :span="12">
            <el-form-item label="生日:" prop="birthday">
              <el-date-picker style="width: 270px" v-model="createParam.birthday" type="date" placeholder="选择日期"
                value-format="timestamp">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- <el-form-item label="课时:" prop="expCardNum">
            <el-input-number
              style="width: 270px"
              placeholder=""
              :precision="0"
              :min="1"
              v-model="createParam.expCardNum"
            ></el-input-number>
          </el-form-item> -->
          <!-- <el-form-item label="等级:" prop="level">
            <el-select placeholder="请选择" style="width: 270px" v-model="createParam.level" clearable="">
              <el-option v-for="item in [
                { label: '一级', value: 1 },
                { label: '二级', value: 2 },
                { label: '三级', value: 3 },
                { label: '四级', value: 4 },
              ]" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
        </el-col>
      </el-row>
      <template v-if="createParam.lessonId == 1">
        <el-row v-for="(v, index) in createParam.userBuyLevels" :key="v">
          <el-col :span="12">
            <el-form-item label="业务等级:">
              <el-select v-model="v.lessonsId" placeholder="请选择" style="width: 270px">
                <el-option v-for="item in storeLessonsList" :disabled="createParam.userBuyLevels
                  .map((mk) => {
                    return Number(mk.lessonsId);
                  })
                  .includes(item.storeLessonId)
                  ? true
                  : false
                  " :key="item.storeLessonId" :label="item.name" :value="item.storeLessonId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="display: flex;align-items: center;">
            <el-form-item label="确认等级:">
              <el-select v-model="v.level" placeholder="请选择" style="width: 150px">
                <el-option v-for="item in levelOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <i class="el-icon-circle-plus" v-if="createParam.userBuyLevels.length - 1 == index"
              style="font-size: 25px; margin-left: 15px;cursor: pointer;color: #409eff;  margin-bottom: 22px;"
              @click="clickAdd"></i>
            <i v-else class="el-icon-remove" @click="clickDele(index)" style=" 
                  font-size: 25px;
                  cursor: pointer;
                  margin-left: 15px;
                  color: #409eff;
                  margin-bottom: 22px;
                "></i>
          </el-col>
        </el-row>
      </template>
      <el-row>
        <el-col :span="12">
          <!-- <el-form-item label="等级:" prop="level">
            <el-select
              placeholder="请选择"
              style="width: 270px"
              v-model="createParam.level"
              clearable=""
            >
              <el-option
                v-for="item in [
                  { label: '一级', value: 1 },
                  { label: '二级', value: 2 },
                  { label: '三级', value: 3 },
                  { label: '四级', value: 4 },
                ]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="小区:">
            <el-input style="width: 270px" v-model="createParam.detailAddress" placeholder="请输入小区"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- <el-form-item label="操作人:" prop="workerInfoId">
            <el-select
              v-model="createParam.workerInfoId"
              clearable
              placeholder="请选择"
              style="width: 270px"
            >
              <el-option
                v-for="item in allWorker"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="渠道:" prop="source">
            <el-select v-model="createParam.source" clearable placeholder="请选择" style="width: 270px">
              <el-option v-for="item in sourceOptions" :key="item.name" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="createParam.source === 'PT带到访'">
          <el-form-item label="二级渠道:" prop="sourceTwo">
            <el-select v-model="createParam.sourceTwo" clearable placeholder="请选择" style="width: 270px">
              <el-option v-for="item in [{ name: 'A' }, { name: 'B' }, { name: 'C' }]" :key="item.name" :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="createParam.source === 'Peferral转介绍'">
          <el-form-item label="介绍人手机号:" prop="introducer">
            <el-input style="width: 270px" v-model="createParam.introducer" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="createParam.source === '异业合作'">
          <el-form-item label="合作方:" prop="sourceTwo">
            <el-select v-model="createParam.sourceTwo" clearable placeholder="请选择" style="width: 270px">
              <el-option v-for="item in frontBizTypeList" :key="item.name" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12" v-if="createParam.source === '网络咨询(NI)'">
          <el-form-item label="二级渠道:" prop="sourceTwo">
            <el-select
              v-model="createParam.sourceTwo"
              clearable
              placeholder="请选择"
              style="width: 270px"
            >
              <el-option
                v-for="item in sourceTwoOptions"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-form-item label="备注:" prop="remark">
        <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入内容" style="width: 600px" maxlength="200"
          v-model="createParam.remark"></el-input>
      </el-form-item>
      <el-form-item label="语音备注:" prop="recording">
        <div style="width: 740px;display: flex;align-items: center;">
          <soundRecording ref="soundRecord" @clickRecStop="clickRecStop" @clickRecClear="clickRecClear" />
          <div v-if="audio" style="margin-left: 20px;">
            <audio controls ref="audio" class="aud" controlsList="nodownload noplaybackrate">
              <source :src="audio" />
            </audio>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer-1">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleCreate('registerRef')">保存</el-button>
    </div>
    <template v-if="showWordDlg">
      <worker-word :key="refreshWord" :word-type="wordType" :t-data="tData" :show="showWordDlg"
        @onWorkerWord="handleWord"></worker-word>
    </template>
  </div>
</template>

<style></style>

<script>
import globaldata from "../../../utils/globaldata";
import { createUserChild } from "../../../api/userChild";
import messageUtils from "../../../utils/messageUtils";
import { frontBizTypeList } from "../../../api/frontBizType";
import soundRecording from "@/components/soundRecording";
import { selectCards } from "@/api/storeFront";
import { newUserByExpCard } from "@/api/userByCard";
import commonUtils from "@/utils/commonUtils";
import WorkerWord from "@/components/WorkerWord/WorkerWord";
import enumsUtil, {
  EAllLevelOptions
} from "../../../utils/enumsUtil";
import { qlLessonTemplate } from "@/api/StoreLesson";

export default {
  name: "UserChildDetail",
  props: {
    // storeLessonExpCards: Array,
    clientData: Object,
  },
  components: {
    soundRecording,
    WorkerWord,
  },
  data() {
    return {
      refreshWord: "",
      wordType: "",
      tData: {},
      showWordDlg: false,
      adminWordDara: {},
      storeLessonExpCards: [],
      storeFrontId: globaldata.getAdminStore().storeFrontId,
      rules: {
        userName: [
          { required: true, message: "请输入家长姓名", trigger: "blur" },
        ],
        userPhone: [
          { required: true, message: "请输入家长手机号", trigger: "blur" },
          { min: 11,  message: '请输入正确的手机号', trigger: 'blur' }
        ],
        name: [{ required: true, message: "请输入会员姓名", trigger: "blur" }],
        gender: [
          { required: true, message: "请选择孩子性别", trigger: "blur" },
        ],
        birthday: [
          { required: true, message: "请选择孩子生日", trigger: "blur" },
        ],
        detailAddress: [
          { required: true, message: "请输入社区", trigger: "blur" },
        ],
      
        lessonId: [
          {
            required: true,
            message: "体验卡类型必填",
            trigger: "change",
          },
        ],
      },
      speRules:{
        expCardNum: [
          { required: true, message: "请输入课时", trigger: "blur" },
        ],
        expCardPay: [
          { required: true, message: "请输入体验卡价格", trigger: "blur" },
        ],
      },
      genderOptions: [
        {
          value: "0",
          label: "男",
        },
        {
          value: "1",
          label: "女",
        },
      ],
      createParam: {},
      allWorker: [],
      sourceOptions: [
        { name: "自然到访(WI)" },
        { name: "电话咨询(CI)" },
        { name: "网络咨询(NI)" },
        { name: "Peferral转介绍" },
        { name: "PT带到访" },
        { name: "CO" },
        { name: "异业合作" },
      ],
      sourceTwoOptions: [
        { name: "美团" },
        { name: "大众点评" },
        { name: "官网" },
        { name: "其他" },
      ],
      frontBizTypeList: [],
      CardType: "A",
      audio: '',
      levelOptions: EAllLevelOptions(),
      storeLessonsList:[]
    };
  },
  mounted() {
    this.initParam();
    globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
    let param = {
      storeFrontId: globaldata.getAdminStore().storeFrontId,
    };
    frontBizTypeList(param).then((response) => {
      this.frontBizTypeList = response.data;
    });
    
  },
  created() { },
  methods: {
    getStoreLessList(){
      qlLessonTemplate({
        lessonId:1,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      }).then((res) => {
        if (res.code == 20000) {
          this.storeLessonsList = res.data
        }
      })
    },
    clickRecStop(audio) {
      if (audio == 1) {
        this.$refs.soundRecord.recStop()
        let timer = setInterval(() => {
          this.audio = this.$refs.soundRecord.audio
          this.$refs.audio.src = this.audio
          this.$refs.soundRecord.dialogVisible = false
          // console.log(this.$refs.soundRecord.audio, 'refs.soundRecord.audio')
          clearInterval(timer)
        }, 500)
      } else {
        let timer = setInterval(() => {
          this.audio = this.$refs.soundRecord.audio
          this.$refs.audio.src = this.audio
          this.$refs.soundRecord.dialogVisible = false
          // console.log(this.$refs.soundRecord.audio, 'refs.soundRecord.audio')
          clearInterval(timer)
        }, 500)
      }
    },
    clickRecClear() {
      this.audio = ''
    },
    changeLessonIdC(e) {
      console.log("changeLessonIdC", e);
      this.$set(this.createParam, "expCardId", null);
      this.$set(this.createParam, "userBuyLevels", this.createParam.lessonId == 1 ? [{
            lessonsId: '',
            level: '',
          }] : []);
      if (e) {
        if(this.createParam.expCardId){
          this.rules = {
            ...this.rules,
            ...this.speRules
          }
        }
      
        this.getStoreLessonCard(e);
        if(e == 1){
          this.getStoreLessList()
        }
      } else {
        // this.$set(this.createParam, "expCardId", null);
        this.storeLessonExpCards = [];
      }
    },
    changeExpCard(e){
      if(e && this.createParam.lessonId){
        this.rules = {
          ...this.rules,
          ...this.speRules
        }
      }
    },
    async getStoreLessonCard(lessonId) {
      let self = this;
      const response = await selectCards({
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        statu: 0,
        exp: 1,
        lessonId,
      });
      if (response.code === 20000) {
        self.storeLessonExpCards = response.data;
      }
    },
    // 初始化参数
    initParam() {
      console.log(this.clientData, "clientData");
      this.createParam = {
        gender: "",
        userPhone:
          this.clientData && this.clientData.mobilePhone
            ? this.clientData.mobilePhone
            : "",
        userName: "",
        phoneCode: "",
        name:
          this.clientData && this.clientData.childName
            ? this.clientData.childName
            : "",
        petName: "",
        birthday: "",
        detailAddress: "",
        expCardId: null,
        expCardPay: 0,
        lessonId: "",
        userBuyLevels:[]
      };
      console.log(this.createParam, "this.createParam");
    },
    getStoreWorkersInfo(workers) {
      this.allWorker = workers;
    },
    handleCancel() {
      this.$emit("onBtnCancel");
    },
    handleCreate(registerRef) {
      this.$refs[registerRef].validate((valid) => {
        if (valid) {
          this.refreshWord = new Date().getTime();
          this.wordType = 1;
          this.showWordDlg = true;
        } else {
          return false;
        }
      });
    },
    handleCommand(command) { },
    doBuyExpCard(param) {
      this.adminWordDara = param;
      this.isAdd();
      // newUserByExpCard(param).then((response) => {
      //   this.closeWordDlg();
      //   let data = response.data;
      //   if (commonUtils.isObjectNull(data)) {
      //     messageUtils.errorMsg(this, response.message);
      //     return;
      //   }
      //   messageUtils.successMsg(this, response.message);
      //   if (response.code === 20000) {
      //     this.isAdd();
      //   }
      // });
    },
    closeWordDlg() {
      this.wordType = 0;
      this.showWordDlg = false;
      this.refreshWord = new Date().getTime();
    },
    isAdd() {
      let param = this.createParam;
      param.storeFrontId = globaldata.getAdminStore().storeFrontId;
      param.createAdminId = globaldata.getAdminStore().id;
      param = {
        ...param,
        adminWord: this.adminWordDara.adminWord,
        recording: this.$refs.soundRecord.audio
      };
      createUserChild(param).then((response) => {
        if (response.code == 20000) {
          messageUtils.successMsg(this, "创建成功");
          this.$emit("onBtnCreate", this.adminWordDara.adminWord);
        } else {
          messageUtils.errorMsg(this, response.message);
        }
      });
    },
    handleWord(wordType, tData) {
      if (wordType == 1) {
        this.doBuyExpCard(tData);
      }
    },
    clickAdd() {
      this.createParam.userBuyLevels.push({
        lessonsId: '',
        level: '',
      })
    },
    clickDele(ind) {
      this.$delete(this.createParam.userBuyLevels, ind)
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/user_child/components/UserChildDetail.vue